import { useTheme } from '@mui/material';

export const IntroIcon1 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
        >
            <rect width="40" height="40" rx="2" fill="white" />
            <path
                d="M9.62322 12.746L20 8.71529L30.3768 12.741C30.5118 15.0214 30.1517 18.582 28.6415 22.0576C27.1312 25.5332 24.4708 28.9238 20 30.8591C15.5292 28.9238 12.8688 25.5382 11.3585 22.0626C9.84826 18.587 9.4882 15.0264 9.62322 12.746ZM31.9771 12.651L31.917 11.6258L30.9569 11.2507L20.5801 7.22504L20 7L19.4199 7.22504L9.04312 11.2507L8.08795 11.6258L8.02794 12.651C7.88292 15.1464 8.27299 18.9671 9.89326 22.6977C11.5285 26.4633 14.444 30.199 19.3649 32.3293L20 32.6044L20.6351 32.3293C25.556 30.199 28.4715 26.4633 30.1067 22.6977C31.727 18.9621 32.1171 15.1464 31.9721 12.651H31.9771ZM25.3659 17.1667L25.931 16.6016L24.8008 15.4715L24.2357 16.0366L18.3997 21.8726L15.7643 19.2371L15.1992 18.672L14.069 19.8022L14.6341 20.3673L17.8346 23.5678L18.3997 24.1329L18.9648 23.5678L25.3659 17.1667Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
